import { Form, useWatch } from '@dagens/frontend-forms';
import { useTranslation } from '@dagens/frontend-i18n';
import { StructuredAddress } from '../../../types/Logistics';
import { DeliveryFormValues } from '.';

const addressEquals = (
  address1?: Partial<StructuredAddress> | string | null,
  address2?: Partial<StructuredAddress> | string | null
) => {
  if (!address1 || !address2) {
    return false;
  }
  if (typeof address1 === 'string' || typeof address2 === 'string') {
    return address1 === address2;
  }

  return (
    address1.addressLine1 === address2.addressLine1 &&
    address1.addressLine2 === address2.addressLine2 &&
    address1.city === address2.city &&
    address1.postalCode === address2.postalCode
  );
};

type DeliveryAddressFeedbackProps = {
  defaultDeliveryAddress?: StructuredAddress | string | null;
};

export const DeliveryAddressFeedback = ({
  defaultDeliveryAddress
}: DeliveryAddressFeedbackProps) => {
  const { t } = useTranslation();
  const deliveryAddress = useWatch<DeliveryFormValues>().deliveryAddress;

  if (
    !defaultDeliveryAddress ||
    !addressEquals(deliveryAddress, defaultDeliveryAddress)
  ) {
    return null;
  }

  return (
    <Form.FeedbackAlert>
      {t('producer:AddCustomer:retrievedFromCvrRegistry')}
    </Form.FeedbackAlert>
  );
};
